// Module
var code = `<miscellaneous-transactions-page header-title="'ATM cash withdrawal'" form-title="'ATM cash withdrawal' | uppercase">
  <form name="\$ctrl.form">
    <table class="misc-transaction__table table table--generate-row-ids">
      <tbody>
      <tr>
        <td></td>
        <td>Category:</td>
        <td>
          <select
              required
              ng-model="\$ctrl.category"
              ng-options="c as c.name for c in \$ctrl.categories"
              ng-change="\$ctrl.updateUnits()">
          </select>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>ATM Terminal:</td>
        <td>
          <select
              required
              ng-model="\$ctrl.atmTerminal"
              ng-options="a as a.terminalId for a in \$ctrl.atmTerminals"
              ng-change="\$ctrl.updateUnits()">
          </select>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Cash amount now:</td>
        <td>
          <cash ng-model="\$ctrl.atmTerminal.totalCash"
                ng-model-options="{ debounce: 100 }"
                ng-disabled="true"></cash>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Amount:</td>
        <td>
          <cash ng-model="\$ctrl.transaction.amount"
                ng-model-options="{ debounce: 100 }"
                disabled
                ng-change="\$ctrl.updateCashAmountAfter()"></cash>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Cash amount after:</td>
        <td>
          <cash ng-model="\$ctrl.transaction.cashAmountAfter"
                ng-disabled="true"></cash>
        </td>
      </tr>
      <tr ng-if="\$ctrl.interbranch">
        <td></td>
        <td>Target branch:</td>
        <td>
          <select
            required
            ng-model="\$ctrl.transaction.targetBranchId"
            ng-options="branch.id as branch.name for branch in \$ctrl.otherBranches">
          </select>
        </td>
      <tr>
        <td></td>
        <td>Remarks:</td>
        <td>
          <input
              type="text"
              maxlength="512"
              ng-model="\$ctrl.transaction.remarks"
              required/>
        </td>
      </tr>
      </tbody>
    </table>

    <ledger-units
        units="\$ctrl.transaction.units"
        entry-type="'CREDIT'"
        amount="\$ctrl.transaction.amount"
        fixed-account-label="'ATM'"
        blocked-units="\$ctrl.blockedUnits"
        hide-contingent="true"
        always-blocked="true">
    </ledger-units>

    <div class="summary-actions">
      <button
          type="button"
          class="btn btn-warning"
          ng-click="\$ctrl.cancel()">
        Cancel
      </button>
      <button
          type="submit"
          class="btn btn-primary"
          ng-disabled="\$ctrl.form.\$invalid"
          ng-click="\$ctrl.save()">
        Transfer now
      </button>
    </div>
  </form>
</miscellaneous-transactions-page>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/atm-cash-withdrawal/atm-cash-withdrawal.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;